import { render } from "./HeroiconsSolidExclamation.vue?vue&type=template&id=16b8db67"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidExclamation.vue"]])

export default __exports__